export default function initializeThirdPartyHacks(global) {
  global.addEventListener('PlaybuzzScriptReady', () => {
    global.PlayBuzz.Feed.renderFeed();
  });
}
